import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Route, Routes, useParams } from 'react-router-dom';
import { useQuery } from '../../../hooks';
import { loadTktInstanceInfos } from '../../../redux';
import { Utils } from '../../../services';
import { Loader } from '../../../components';
import { Nav, Navbar } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { ApplicationForm } from './ApplicationForm';
import { Workflow } from './Workflow';

import './Instance.css';

const Instance = (_props) => {
    const dispatch          = useDispatch();
    const { t, i18n }       = useTranslation();
    const { slug }          = useParams();
    const { instanceInfos } = useSelector(state => state.tktInstances);
    const { isEmbedded }    = useSelector(state => state.ui);
    const current_lng       = Utils.i18nUiLang(i18n);

    const { lang } = useQuery();

    useEffect(() => {
        if (slug)
            dispatch(loadTktInstanceInfos(slug));
    }, [dispatch, slug]);

    useEffect(() => {
        if (lang)
            i18n.changeLanguage(lang);
    }, [i18n, lang]);

    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
    };

    const languages = React.useMemo(() => {
        if (!instanceInfos)
            return [];

        const languages = instanceInfos.l10n?.locales?.all?.map(locale => locale.substring(0, 2));
        if (languages?.length && !languages.includes(current_lng))
            i18n.changeLanguage(languages[0]);

        return languages;
    }, [current_lng, i18n, instanceInfos]);

    if (!instanceInfos)
        return (
            <div className="loader-wrapper center light">
                <Loader color="#454545" />
            </div>
        );

    return (
        <div className={`Instance text-center ${isEmbedded ? 'embedded' : ''}`}>
            {!isEmbedded && (
                <Navbar className="TopBar fixed-top flex-md-nowrap p-0 shadow" expand="md">
                    <Nav className={`ml-auto langsNav mr-3`} navbar>
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret>
                                <i className="fa fa-globe"></i>&nbsp;{t(`languages.${current_lng}`)}
                            </DropdownToggle>
                            <DropdownMenu right>
                                {languages.map((lng, _i) =>
                                    <DropdownItem key={lng} className={current_lng === lng ? 'active' : ''} onClick={() => {changeLanguage(lng); }}>
                                        {t(`languages.${lng}`)}
                                    </DropdownItem>
                                )}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Nav>
                </Navbar>
            )}
            <div className="wrapper">
                {!isEmbedded && (
                    <div className="container">
                        <img src={instanceInfos.customer?.logo?.rfc2397_data} className="logo" alt="logo" />
                    </div>
                )}
                <Routes>
                    <Route
                        path="application/:applicationTypeId"
                        element={<ApplicationForm tkt_instance_id={instanceInfos.id} />}
                    />
                    <Route
                        path="workflow/:workflow_id"
                        element={<Workflow tkt_instance_id={instanceInfos.id} />}
                    />
                    <Route
                        path="workflow/resume"
                        element={<Workflow tkt_instance_id={instanceInfos.id} />}
                    />
                </Routes>
            </div>
        </div>
    );
}

export default Instance;
